import { useMemo } from 'react';
import { useGlobalState } from 'src/stateProviders/GlobalStateProvider';

const useReadOnlyEngineerSeptic = () => {
	const { company } = useGlobalState() ?? {};
	return useMemo(() => Boolean(company?.readOnlyEngineerSeptic), [company]);
};

export default useReadOnlyEngineerSeptic;
